import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="min-h-screen bg-sand-50 grain">
      <nav className="sticky top-0 z-50 glass">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="font-serif text-2xl text-stone-900" data-testid="terms-brand">
            Skin<span className="text-sage-400">sights</span>
          </Link>
          <Link to="/" className="text-sm text-stone-600 hover:text-stone-900">Home</Link>
        </div>
      </nav>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <p className="text-xs uppercase tracking-[0.2em] text-sage-500">Last updated · Feb 2026</p>
        <h1 className="font-serif text-5xl tracking-tight text-stone-900 mt-2">Terms of Service</h1>

        <div className="prose prose-stone mt-8 max-w-none text-stone-700 leading-relaxed space-y-5">
          <p>By creating an account you agree to these terms.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">1. Not medical advice</h2>
          <p>Skinsights is a <strong>personal wellness journal</strong>. It does not diagnose, treat, cure, or prevent any condition. AI-generated observations are informational only. Always consult a qualified dermatologist or healthcare professional for medical concerns. Do not delay seeking medical care based on anything in this app.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">2. Your account</h2>
          <p>You're responsible for keeping your password safe and for everything done under your account. If you suspect unauthorized access, change your password in Settings immediately.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">3. Your content</h2>
          <p>You own your photos, notes, and entries. We only process them to provide the service to you. If you delete your account, your content is removed from our systems within 30 days.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">4. AI features</h2>
          <p>Photos analyzed by the "Analyze with AI" feature are sent to Anthropic for inference. We don't store them at the AI provider. AI output is best-effort and may be wrong. Always sanity-check the results — and never act on AI suggestions without a real clinician.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">5. Acceptable use</h2>
          <p>Don't upload content that isn't yours, don't try to break into other accounts, and don't use the app for anything illegal. We may suspend accounts that abuse the service.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">6. No warranties</h2>
          <p>Skinsights is provided "as is" without warranties of any kind. We don't guarantee uptime, accuracy of AI output, or that the app will be free of bugs.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">7. Limitation of liability</h2>
          <p>To the extent permitted by law, our total liability is limited to the amount you paid for the service in the prior 12 months (which is zero if you use the free version). We're never liable for indirect or consequential damages.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">8. Changes</h2>
          <p>We may update these terms. We'll show a notice in the app for material changes. Continued use after changes means you accept the new terms.</p>

          <h2 className="font-serif text-2xl text-stone-900 mt-8">9. Contact</h2>
          <p>Questions? <a href="mailto:hello@skinsights.app" className="text-sage-500 underline">hello@skinsights.app</a></p>
        </div>
      </main>
    </div>
  );
}
